.fa-trash-alt:hover{color:#c50707}
/*# sourceMappingURL=supplier-actions.component-WI2TPXXN.css.map */
